export default __webpack_public_path__ + "static/B0039-3eeba52aac9bca068088864ae384047f.png";